import React from 'react'
import PropTypes from 'prop-types'
import { find, isFunction } from 'lodash-es'

const render = ({ children = null }) =>
  isFunction(children) ? children() : children
const Then = (opt) => render(opt)
const thenType = (<Then />).type
const Else = (opt) => render(opt)
const elseType = (<Else />).type

const If = ({ children, condition }) => {
  const childrenArr = React.Children.toArray(children)
  const thenNode = find(childrenArr, (child) => child.type === thenType)

  if (condition) {
    return thenNode || children
  }

  const elseNode = find(childrenArr, (child) => child.type === elseType)
  return elseNode || null
}

If.propTypes = {
  condition: PropTypes.bool.isRequired,
  children: PropTypes.node,
}

export { Then, Else }
export default If
